<template>
    <div>
        <h2 class="m-0 h1 text-uppercase">{{ $t('partido.selecciona_entradas', { manager: manager.termino_entradas }) }}</h2>
        <h3 class="subtitle h3 light mb-3">A) {{ $t('partido.pinchando_mapa') }}:</h3>
        <RenderSvgComponent
            :svg="reserva.place_svg"
            :zonas="zonas_disponibles"
            @clickZona="seleccionarZona"
        />
    </div>
</template>

<script>
    import RenderSvgComponent from '@/components/common/svg/normal/RenderSvgComponent';

    export default {
        props: {
            reserva: {
                type: Object,
                required: true
            },
            zonas_disponibles: {
                type: Array,
                required: true
            }
        },
        methods: {
            seleccionarZona(zona) {
                const seats = JSON.parse(JSON.stringify(this.reserva.seat_map.find(zona_map => zona_map.region_id === zona.id).asientos));
                this.$emit('seleccionarZona', seats, zona);
            }
        },
        computed: {
            manager() {
                return this.$store.getters.getFooter;
            }
        },
        components: {
            RenderSvgComponent
        }
    }
</script>